<template>
  <div class="form-header">
    <div class="form-header__title font--bold -xl -color1 mt-12 mb-3">
      <span class="ml-3">{{header}}</span>
    </div>
  </div>
</template>
<script>

export default {
 props:['header']
}
</script>